import { useEffect, useState } from "react";
import "./UserAccountTransfers.scss";
import {
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import RegistrationSelect from "../../UI/Registration/RegistrationSelect";
import RegistrationInput from "../../UI/Registration/RegistrationInput";
import { setAsArray } from "../../../util/utilfunctions/utilFunctions";
import Contacts from "./Contacts";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import InternationalTransferHistory from "./InternationalTransfers/InternationalTransferHistory";
import InternationalTransferFooterButtons from "./InternationalTransfers/InternationalTransferFooterButtons";
import PinPad from "../../PinPad/PinPad";
import { useSelector } from "react-redux";
import InternationalTransferSummary from "./InternationalTransfers/InternationalTransferSummary";
import InternationalTransferTrack from "./InternationalTransfers/InternationalTransferTrack";
import {
  getMoneyGramErrorMessage,
  moneyGramAPI,
  stripNamespaces,
} from "../../../util/API/moneygram";
import MoneyGramReceiverFields from "./InternationalTransfers/MoneyGramReceiverFields";
import { serviceUrl } from "../../../config";

function Moneygram({ handleBack }) {
  const [page, setPage] = useState("landing");
  const [contacts, setContacts] = useState(null);
  const [history, setHistory] = useState(null);
  const [relationships, setRelationships] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [alert, setAlert] = useState({});
  const [showPin, setShowPin] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [countries, setCountries] = useState([]);
  const [contactButtonText, setContactButtonText] = useState("Save contact");
  const [receiverObj, setReceiverObj] = useState({});
  const [disableContactButton, setDisableContactButton] = useState(false);
  const [orderStatus, setOrderStatus] = useState("");
  const [cancelReasons, setCancelReasons] = useState([]);
  const [cancelFormValues, setCancelFormValues] = useState({});
  const [payoutOptions, setPayoutOptions] = useState([]);
  const [payoutOptionsSelectable, setPayoutOptionsSelectable] = useState([]);
  const [receiverFields, setReceiverFields] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState({});
  const [prevDeliveryOption, setPrevDeliveryOption] = useState(null);
  const [showFraudDialog, setShowFraudDialog] = useState(false);
  const [fraudChecked, setFraudChecked] = useState(false);
  const [refundDetails, setRefundDetails] = useState({});
  const [stateProvinceInfo, setStateProvinceInfo] = useState([]);
  const [amendForm, setAmendForm] = useState({
      receiverfirstname: "",
      receiverlastname: "",
      referencenumber: "",
      mgitransactionsessionid: ""
    });

    const [hasSelectedPayout, setHasSelectedPayout] = useState(false);


    const parentuserid = sessionStorage.getItem("parentuserid");
 
    let isOperator = sessionStorage.getItem("isOperator");
 
    // const BACKEND_URL = serviceUrl;
    let configVariables = useSelector((state) => state.config.baseConfig);
    let isDevEnv = configVariables.devEnvironment;

     const FRAUD_WARNING = `
      IMPORTANT INFORMATION - Fraud Warning About Your Money Transfer
      Keep your money safe. If any of the below apply, DO NOT SEND the money transfer. It’s a scam and 
      someone is trying to steal your money. If you send money, it can be paid out quickly, and you may 
      not be able to get a refund.
      #1 Never transfer money to a stranger. Know who you are dealing with. A money transfer is like cash. 
      #2 Never send money in the following situations:
      • To make a charity donation or to pay an internet merchant for supplies during a pandemic, 
      natural disaster, or other crisis
      • To receive money (examples: lottery winnings, prize, job offer or loan)
      • To pay a government taxing authority or the police
      • To buy a car, puppy, another unique or high-value item, or to make an apartment deposit
      #3 Never send money without checking out the story. Reach out to that friend or family member you 
      heard is in need first.
      #4 If it sounds too good to be true, it probably is.
      #5 Never give your transaction reference number to anyone other than the person you intend to 
      receive the money. Sellers and telemarketers can’t take money transfer payments from people in the 
      US for something they’re selling through telemarketing. If you’ve lost money to a scam via 
      MoneyGram, call MoneyGram at [insert local number] or visit www.moneygram.com to file a fraud 
      report.
      `.trim();


      

  const selectedUser = useSelector((state) => state.usersList.selectedUser);
  const selectedUserID = selectedUser.User.id;
  let agent = sessionStorage.getItem("user");
  agent = JSON.parse(agent);
  agent = agent.payload.body.User;

  useEffect(() => {
    getInitData();
  }, []);


    const decodeHtmlEntities = (str) => {
  if (!str || typeof str !== 'string') return '';
  console.log("Decoding string:", str);  // Log input string
  const decoded = str
    .replace(/&#039;/g, "'")  // Apostrophe
    .replace(/&amp;/g, "&")   // Ampersand
    .replace(/&lt;/g, "<")    // Less than
    .replace(/&gt;/g, ">")    // Greater than
    .replace(/&quot;/g, '"'); // Quote
  console.log("Decoded string:", decoded);  // Log output
  return decoded;
};


 const getInitData = async () => {
  const requestData = {
    ...formValues,
    ...selectedUser.User,
    userid: selectedUserID,
  };
  const response = await moneyGramAPI(requestData, "getInitData");

  console.log("getInitData_response===============",response);

  const codeList =
    response?.codeList?.payload?.body?.Envelope["soapenv:Body"][
      "ac:codeTableResponse"
    ];
  const countryData = codeList["ac:countryInfo"];

  console.log("countryData inside Codelist", countryData);
  const seen = new Set();
  //MG has duplicate keys for countries, we must filter them out
  const countries = countryData
    .filter((country) => {
      if (seen.has(country["ac:countryCode"])) return false;
      seen.add(country.countryCode);
      return true;
    })
    .map((country) => ({
      key: country["ac:countryCode"],
      value: country["ac:countryCode"],
      label: country["ac:countryName"],
      isSendActive: country["ac:sendActive"] === "true",
    }));
  const countryCurrencyInfo = codeList["ac:countryCurrencyInfo"];
  const stateProvinceInfo = codeList["ac:stateProvinceInfo"];
  const currencyInfo = codeList["ac:currencyInfo"];
  const contacts = setAsArray(response.contacts.payload.record);
  console.log(
    "response.contacts.payload==========",
    response.contacts.payload
  );


  
const stateProvinceInfoRaw = codeList["ac:stateProvinceInfo"];
const stateProvinceArray = setAsArray(stateProvinceInfoRaw);  

// Get sender's country and state from the logged-in user
const senderCountryIso3 = selectedUser.User.countryid;  
const senderStateId     = selectedUser.User.stateid;    

console.log("%c SENDER INFO", "background: #333; color: yellow; font-weight: bold");
console.log("senderCountryIso3 :", senderCountryIso3);
console.log("senderStateId     :", senderStateId);

// Filter states for the sender's country only
const senderCountryStates = stateProvinceArray.filter(
  item => item["ac:countryCode"] === senderCountryIso3
);
setStateProvinceInfo(stateProvinceArray);

console.log(`%c STATE/PROVINCE INFO FOR ${senderCountryIso3} (${senderCountryStates.length} entries)`, 
  "background: blue; color: white; font-weight: bold");

console.table(
  senderCountryStates.map(item => ({
    countryCode       : item["ac:countryCode"],
    stateProvinceCode : item["ac:stateProvinceCode"],   // ← this is what MoneyGram gives
    stateProvinceName : item["ac:stateProvinceName"],
    matchesOurStateId : item["ac:stateProvinceCode"] === senderStateId ? "YES" : "no"
  }))
);

 // Highlight the exact match
 const exactMatch = senderCountryStates.find(
   item => item["ac:stateProvinceCode"] === senderStateId
 );

 if (exactMatch) {
   console.log("%c EXACT MATCH FOUND →", "background: green; color: white; font-weight: bold", {
     ourStateId: senderStateId,
     moneyGramCode: exactMatch["ac:stateProvinceCode"],
     name: exactMatch["ac:stateProvinceName"]
   });
 } else {
   console.log("%c NO MATCH FOR stateid:", "background: red; color: white", senderStateId);
 }

  const history = setAsArray(response.history.payload.body.record);
  let relationshipData = setAsArray(response.relationships.payload.record);
  relationshipData = relationshipData.map((relationship) => {
    const data = relationship.domainattributes;
    return {
      key: data.domainatt,
      value: data.domainatt,
      label: data.attname,
    };
  });
  console.log("history----------",history);
  setHistory(history);
  console.log("history we r getting from get init data",history);
  setContacts(contacts);
  setRelationships(relationshipData);
  setCountries(countries);
  const kyc = response.kyc;
  setUserData(kyc);
  setFormValues({...selectedUser.User, userid: selectedUserID, authUser: agent.id, agentName: agent.firstName + " " + agent.lastName, 'clerkname': agent.firstName + " " + agent.lastName,isOperator:isOperator, parentuserid: parentuserid || selectedUserID,});
  if (selectedUser.User.stateid) {
  editFormValues("actualsenderstateid", selectedUser.User.countryid === "TCA" ? "" : selectedUser.User.stateid);
  console.log("%c Saved original stateid as actualsenderstateid →", "color: orange; font-weight: bold", selectedUser.User.stateid);
}
};

  const handlePinConfirm = (event, pin) => {
  console.log("handlePinConfirm FIRED", {
    transferType: formValues.transferType,
    pinLength: pin.length,
    showPin,
  });
  pin = pin.join("");
  if (
    formValues.transferType === "send" ||
    formValues.transferType === "resend"
  ) {
    sendMoney(pin);
  } else if (formValues.transferType === "receive") {
    console.log("→ Calling receiveMoney");
    receiveMoney(pin);
  }
  // Removed calls to confirmCancel and confirmAmend since they don't use PIN pad now
  setShowPin(false);
};


  const parseHoldMessage = (xmlStr) => {
  console.log("Raw XML input to parser:", xmlStr);  // Log input
  if (!xmlStr || typeof xmlStr !== 'string') {
    console.log("XML is undefined or invalid - skipping");
    return '';
  }
  if (!xmlStr.includes('ON HOLD')) {
    console.log("No 'ON HOLD' found in XML - skipping");
    return '';
  }
  const startTag = '<ac:referenceNumberConsumerText>';
  const endTag = '</ac:referenceNumberConsumerText>';
  const start = xmlStr.indexOf(startTag) + startTag.length;
  const end = xmlStr.indexOf(endTag, start);
  console.log("Start index:", start, "End index:", end);  // Log positions
  if (start === -1 || end === -1) {
    console.log("Tags not found - returning empty");
    return '';
  }
  const consumerText = xmlStr.substring(start, end).trim();
  console.log("Extracted consumerText:", consumerText);  // Log result
  return consumerText;
};

 const sendMoney = async (pin) => {
  setPage("wait");
  let response = await moneyGramAPI(formValues, "sendMoney", {
    transactionDetails: JSON.stringify(transactionDetails),
    PIN: pin,
  });
  console.log("Full sendMoney API response:", response);
  if (response.Status === "2" && response.payload?.msg === "Wrong user id or pin code") {
    setAlert({
      showAlert: true,
      severity: "error",
      message: response.payload.msg,
      header: "Invalid PIN",
    });
    
    setPage("summary");
    return;
  }
  if (response.Status !== "1") {
    setAlertData(response, true);
    return;
  }
  // NEW: Hardcode hold message if "ON HOLD" detected
  if (response.payload?.paymentresponse && response.payload.paymentresponse.includes('ON HOLD')) {
    console.log("Detected 'ON HOLD' in payload.paymentresponse - showing hardcoded alert");
    setAlert({
      showAlert: true,
      severity: "warning",
      message: "TRANSACTION ON HOLD: Contact MoneyGram to provide additional information before funds can be available to your receiver.Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com.",
      header: "Transaction On Hold"
    });
  } else {
    console.log("No payload.paymentresponse or no 'ON HOLD' - skipping alert");
  }
  let confcode = response.payload.confcode;
  let trngrpid = response.payload.trngrpid;
  editTransactionDetails("confcode", confcode);
  editTransactionDetails("trngrpid", trngrpid);
  setPage("receipt");
};
  const fetchContacts = async () => {
  const requestData = {
    ...formValues,
    ...selectedUser.User,
    userid: selectedUserID,
  };
  const response = await moneyGramAPI(requestData, "getInitData");  // Reuse the same API endpoint
  const contacts = setAsArray(response.contacts.payload.record);  // Extract just contacts
  setContacts(contacts);  // Update state
};

   const saveContact = async () => {
  console.log("saveContact() → Starting...");

  
  const cleanTransactionDetails = { ...transactionDetails };
  
  // Remove ONLY the fields mobile removes BEFORE saving
  delete cleanTransactionDetails.deliveryoption;
  delete cleanTransactionDetails.kyc;
  delete cleanTransactionDetails.amount;
  delete cleanTransactionDetails.fees;
  delete cleanTransactionDetails.taxes;
  delete cleanTransactionDetails.adminFees;
  delete cleanTransactionDetails.totalAmountToCollect;
  delete cleanTransactionDetails.mgiTransactionSessionID;
  delete cleanTransactionDetails.receiveAmount;
  delete cleanTransactionDetails.payoutCurrency;

  cleanTransactionDetails.type = 'MoneyGram';

  // Duplicate name check 
  if (contacts && contacts.length) {
      for (const contact of contacts) {
        const savedContactName = contact.Usercontactlistexternal.lastName.trim().replace(/\s+/g, ' ');
        const hasMiddleName = cleanTransactionDetails.receiverMiddleName && cleanTransactionDetails.receiverMiddleName.length;
        const hasSecondLastName = cleanTransactionDetails.receiverLastName2 && cleanTransactionDetails.receiverLastName2.length;
        const firstName = cleanTransactionDetails.receiverFirstName || '';
        const lastName = cleanTransactionDetails.receiverLastName || '';
        const newContactName = `${firstName}${hasMiddleName ? ' ' + cleanTransactionDetails.receiverMiddleName : ''} ${lastName}${hasSecondLastName ? ' ' + cleanTransactionDetails.receiverLastName2 : ''}`;
        if (savedContactName.toLowerCase() === newContactName.toLowerCase()) {
          setContactButtonText('Contact Already Exists');
          return;
        }
      }
  }


  console.log("trasnaction details before saving contact",cleanTransactionDetails);
  
  const contactDetailsString = JSON.stringify(cleanTransactionDetails);
    // .replace(/"/g, '&quot;'); 
    console.log("string that we are sendinf",contactDetailsString);

  try {
    const response = await moneyGramAPI(formValues, "createExternalContact", {
      contactDetails: contactDetailsString,
    });

    if (response.Status !== "1") {
      setContactButtonText("Could not save contact");
      return;
    }

    setContactButtonText("Contact Saved");
    setDisableContactButton(true);
    await fetchContacts(); 
  } catch (err) {
    setContactButtonText("Save failed");
    console.error("Exception:", err);
  }
};
  const getPayoutOptions = async () => {
  setPage("wait");
  let response = await moneyGramAPI(formValues, "MoneyGramFeeLookup", {
    transactionDetails: JSON.stringify(transactionDetails),
  });
  if (response.Status !== '1') {
    setAlertData(response, true);
    return;
  }
  response = stripNamespaces(response);
  const feeInfo = setAsArray(
    response.payload.body.Envelope.Body.feeLookupResponse.feeInfo
  );
  setPayoutOptions(feeInfo);
  console.log(feeInfo);
  // Track duplicates by combining deliveryOptDisplayName and validReceiveCurrency
  const nameCurrencyCount = {};
  const abbreviationMap = {}; // Track receiveAgentAbbreviation for each key
  feeInfo.forEach((option) => {
    const key = `${option.deliveryOptDisplayName}|${option.validReceiveCurrency}`;
    nameCurrencyCount[key] = (nameCurrencyCount[key] || 0) + 1;
    // Store receiveAgentAbbreviation for this key
    if (!abbreviationMap[key]) {
      abbreviationMap[key] = new Set();
    }
    if (option.receiveAgentAbbreviation) {
      abbreviationMap[key].add(option.receiveAgentAbbreviation);
    }
  });
  const selectableOptions = feeInfo.map((option, index) => {
    let label = `${option.validReceiveCurrency} - ${option.deliveryOptDisplayName}`;
    // Check for duplicates
    const key = `${option.deliveryOptDisplayName}|${option.validReceiveCurrency}`;
    if (nameCurrencyCount[key] > 1) {
      // If receiveAgentAbbreviation is the same for all duplicates, use receiveAgentName
      const suffix =
        abbreviationMap[key].size === 1 && option.receiveAgentName
          ? option.receiveAgentName
          : option.receiveAgentAbbreviation || option.receiveAgentName || "";
      if (suffix) {
        label += ` (${suffix})`;
      }
    }
    return { key: index, value: JSON.stringify(option), label };
  });
  // NEW: Check for no valid options (fees too high)
  const validOptions = selectableOptions.filter(opt => {
    const parsed = JSON.parse(opt.value);
    return parseFloat(parsed.receiveAmounts.receiveAmount) > 0;
  });
  
  if (validOptions.length === 0) {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Send amount will be $0.00 after fees. Please enter a larger amount.",
      header: "Invalid Amount",
    });
    return; // Prevent proceeding
  }
  setPayoutOptionsSelectable(selectableOptions);
  if (formValues.transferType === "resend") {
  setHasSelectedPayout(false);
}
  
  setPage("sendpage2");
};


  const getMoneyGramErrorMessage = (response) => {
// PRIORITY 1: payload.msg (skip generic)
if (response?.payload?.msg) {
const msg = response.payload.msg;
if (msg !== "Something went wrong." && msg.trim() !== "") {
return msg;
}
}
// PRIORITY 2: Nested errorString / detailString / faultstring
const apiresponse = response?.payload?.header?.apiresponse || response?.payload?.apiresponse;
const Envelope = apiresponse?.Envelope;
const Body = Envelope?.["soapenv:Body"] || Envelope?.Body;
const Fault = Body?.["soapenv:Fault"] || Body?.Fault;
if (Fault) {
const faultstring = Fault.faultstring || Fault["soapenv:faultstring"];
// NEW: Specific handling for "Fee is too high"
if (faultstring === "Fee is too high") {
return "Send amount will be $0.00 after fees. Please enter a larger amount.";
}
if (faultstring) {
return faultstring;
}
}
const detail = Fault?.detail;
if (detail) {
const errorsObj = detail.errors || detail["ac:errors"] || detail["ns1:errors"];
const errors = setAsArray(errorsObj);
let errorMsg = '';
for (const errItem of errors) {
const moneygramError = errItem.error || errItem["ac:error"] || errItem["ns1:error"];
let errorString = moneygramError.errorString || moneygramError["ac:errorString"] || moneygramError.detailString || moneygramError["ac:detailString"] || moneygramError["ns1:errorString"] || moneygramError["ns1:detailString"];
if (errorString) {
errorString = decodeHtmlEntities(errorString);
errorString = errorString
.replaceAll(/'/g, '')
.replaceAll(/"/g, '')
.replaceAll('{', '')
.replaceAll('}', '')
.replaceAll('cvc-complex-type.2.4.a: Invalid content was found starting with element', '')
.replaceAll('http://www.moneygram.com/AgentConnect1512:', '')
.replaceAll('senderPhotoIdType.', '');
errorMsg += errorString.trim() + "<br/>";
}
}
if (errorMsg) return errorMsg;
}
// PRIORITY 3 (new): payload.header.msg or payload.header.errorNo (your new error format)
if (response?.payload?.header?.msg) {
const msg = response.payload.header.msg;
if (msg !== "Something went wrong." && msg.trim() !== "") {
return msg;
}
} else if (response?.payload?.header?.errorNo) {
return response.payload.header.errorNo;
}
// PRIORITY 4: Fallback to error / errorNo
if (response?.payload?.error) {
return response.payload.error;
} else if (response?.payload?.errorNo) {
return response.payload.errorNo;
}
// Final fallback
return response?.payload?.msg || "Transaction failed. Please try again.";
};

  useEffect(() => {
    if (selectedContact) {
      setPage("contact");
    }
  }, [selectedContact]);

  useEffect(() => {
    if (page === "sendpage1" || page === "sendpage2") {
      editFormValues("transferType", "send");
    } else if (page === "receive") {
      editFormValues("transferType", "receive");
    } else if (page === "shortform") {
      console.log("chnaging transferType to resend");
      editFormValues("transferType", "resend");
      

    }
  }, [page]);

  const getContactInformation = () => {
    if (!selectedContact) return;
    const data = selectedContact.Usercontactlistexternal;
    let otherdata = {};
    try {
      otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
      console.log("otherdata in current contact",otherdata)
    } catch (error) {}
    let name = selectedContact.Usercontactlistexternal.lastName;

    const receiverAddressData = otherdata.address;
    const address = receiverAddressData?.line1;
    const city = receiverAddressData?.city;
    const stateProvince = receiverAddressData?.stateProvince;
    const country = otherdata.receivercountry;

    const addressText = `${address ? address + ", " : ""}${
      city ? city + ", " : ""
    }${stateProvince ? stateProvince + ", " : ""}${country}`;

    return (
      <Box>
        <Box>Name: {name}</Box>
        <Box>Address: {addressText}</Box>
      </Box>
    );
  };

    const sendToContact = (item) => {
    let contactOther = JSON.parse(
      selectedContact.Usercontactlistexternal.other.replaceAll(
        /&(amp;)*quot;/g,
        '"'
      )
    );
    setFormValues((prev) => ({
      ...prev,
      receivercountry: contactOther.ctry,
      receivercurrency: contactOther.cur,
      payoutmethod: contactOther.payout,
    }));
      

    //Merge contactOther into transactionDetails
  setTransactionDetails((prev) => {
    const newTransactionDetails = {
      ...prev,
      ...contactOther, // Merge all contact fields
    };
    console.log("Updated transactionDetails in sendToContact:", newTransactionDetails);
    return newTransactionDetails;
  });
      console.log("details about transactions",transactionDetails)
    
    setReceiverObj({
      receiver: contactOther.receiver,
    });
    setPage("shortform");
  };

  const resendTransaction = async (item) => {
    try {

      

      console.log("transfer type in resendTRansaction",formValues.transferType);
      let itemData = JSON.parse(item);
      let prevTransDetails =
        typeof itemData.transactionDetails === "object"
          ? itemData.transactionDetails
          : JSON.parse(itemData.transactionDetails);

          console.log(prevTransDetails);

      // Store previous deliveryoption separately
      setPrevDeliveryOption(prevTransDetails.deliveryoption || null);
      console.log("prevdetails in resend",prevTransDetails);

      console.log("deliveryoptions in prevdetails",prevTransDetails.deliveryoption);

      // Remove fields that should not be reused
      delete prevTransDetails.redirect_s;
      delete prevTransDetails.quoteId;
      delete prevTransDetails.amount;
      delete prevTransDetails.amounttype;

      // Update transactionDetails with previous transaction data
      setTransactionDetails((prev) => ({
        ...prev,
        ...prevTransDetails,
      }));

        

      // Navigate to shortform
      setPage("shortform");
    } catch (error) {
      console.error("Error in resendTransaction:", error);
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Failed to process resend transaction.",
        header: "Error",
      });
      setPage("landing");
    }
  };

  const editFormValues = (key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const editTransactionDetails = (key, value) => {
    setTransactionDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const setAlertData = (response, isError) => {
    if (isError) {
      let errorMessage = "";
      errorMessage += getMoneyGramErrorMessage(stripNamespaces(response));
      setAlert({
        showAlert: true,
        severity: "error",
        message: errorMessage,
        header: "Error",
      });
      setPage("landing");
    }
  };

  const getFieldData = async (navigate = true) => {
    setPage("wait");
    let response = await moneyGramAPI(
      formValues,
      "MoneyGramGetFieldsProductRequest",
      { transactionDetails: JSON.stringify(transactionDetails) }
    );
    response = stripNamespaces(response);
    const fields = setAsArray(
      response.payload.body.Envelope.Body.getFieldsForProductResponse
        .productFieldInfo
    );
    console.log("feilds from ffp", fields);
    setReceiverFields(fields);
    if (navigate) {
      setPage("sendpage3");
    } // Only navigate if navigate is true
  };

  const validateForm = () => {
  let hasError = false;
  let errors = {};

  console.log("transfer type is ", formValues.transferType);

  // const compulsoryFields = formValues.transferType === "resend"
  // ? ["receiverFirstName", "receiverLastName"]
  // : ["receiverFirstName", "receiverLastName", "sendPurposeOfTransaction", "senderIntendedUseOfMGIServices"];
  const compulsoryFields = ["receiverFirstName", "receiverLastName", "sendPurposeOfTransaction", "senderIntendedUseOfMGIServices"];
  const fieldsToSkipValidation = [
    "amount",
    "consumerId",
    "deliveryOption",
    "destinationCountry",
    "formFreeStaging",
    "mgiTransactionSessionID",
    "receiveAgentID",
    "receiveCurrency",
    "relationshipToReceiver",
    "sendCurrency",
    "senderAddress",
    "senderCitizenshipCountry",
    "senderCity",
    "senderCountry",
    "senderFirstName",
    "senderHomePhone",
    "senderHomePhoneCountryCode",
    "senderLastName",
    "senderLegalIdNumber",
    "senderLegalIdType",
    "senderPhotoIdCountry",
    "senderPhotoIdNumber",
    "senderPhotoIdType",
    "senderDOB",
  ];
  // Existing REQ field validation
  if (receiverFields) {
    receiverFields.forEach((field) => {
      if (field.visibility === "REQ") {
        const fieldName = field.xmlTag;
        const fieldValue = transactionDetails[fieldName];
        if (fieldsToSkipValidation.includes(fieldName)) {
          return;
        }
        if (!fieldValue) {
          hasError = true;
          errors[fieldName] = "This field is required.";
        }
        if (field.fieldMin && fieldValue && fieldValue.length < field.fieldMin) {
          hasError = true;
          errors[fieldName] = `Minimum length is ${field.fieldMin}.`;
        }
        if (field.fieldMax && fieldValue && fieldValue.length > field.fieldMax) {
          hasError = true;
          errors[fieldName] = `Maximum length is ${field.fieldMax}.`;
        }
      }
    });
  }
  // New: Explicit checks for compulsory fields
  compulsoryFields.forEach((fieldName) => {
    const fieldValue = transactionDetails[fieldName];
    if (!fieldValue || fieldValue.trim() === "") {
      hasError = true;
      errors[fieldName] = "This field is required.";
    }
  });

  setFormErrors(errors);
  return !hasError;
};

// Add this new validation function after validateSendPage1
const validateShortForm = () => {
  let errors = {};
  let isValid = true;
  if (!transactionDetails.amounttype) {
    errors.amounttype = true;
    isValid = false;
  }
  if (!transactionDetails.amount || parseFloat(transactionDetails.amount) <= 0) {
    errors.amount = true;
    isValid = false;
  }
  setFormErrors(errors);
  if (!isValid) {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Please fill all the fields properly",
      header: "Validation Error",
    });
  }
  return isValid;
};

// In shortform JSX, update the footer buttons handleButtonTwo


  const getQuote = async () => {
    // If receiverFields are needed and not available, fetch them silently (no navigation)
    if (!receiverFields && formValues.transferType === "resend") {
      await getFieldData(false); // Fetch without navigating to sendpage3
    }

     console.log(formValues.transferType==="resend");
    const isValid = validateForm();

    if (!isValid) {
  // Build a list of missing/invalid fields using labels from receiverFields
  let missingFields = [];
  receiverFields?.forEach((field) => {
    const fieldName = field.xmlTag;
    if (formErrors[fieldName]) {
      const label = field.fieldLabel || fieldName; // Use fieldLabel if available, fallback to xmlTag
      missingFields.push(label);
    }
  });
  const message = missingFields.length > 0
    ? `Please fill out the following required fields correctly: ${missingFields.join(', ')}`
    : "Please fill out all required fields correctly.";
  setAlert({
    showAlert: true,
    severity: "error", // Use 'severity' to match other alert usages (e.g., setAlertData)
    message: message,
    header: "Validation Error",
  });
  return;
}

    console.log("isValid==============", isValid);

    console.log("getQuote-------------", receiverFields);
    let dynamicFields = {};

    if (receiverFields?.length > 0) {
      receiverFields?.forEach((val) => {
        // Check if the field is dynamic
        if (val?.dynamic === "true") {
          console.log("ReceiverFields-------------", val);

          // If the field is dynamic, move the corresponding key-value pair from transactionDetails to dynamicFields
          const xmlTag = val?.xmlTag;
          if (transactionDetails.hasOwnProperty(xmlTag)) {
            dynamicFields[xmlTag] = transactionDetails[xmlTag];

            // Remove the dynamic field from transactionDetails
            delete transactionDetails[xmlTag];
          }
        }
      });
    }
    console.log("transactionDetailsold=================", transactionDetails);
      // Add operatorsName to transactionDetails
    const operatorsName = `${selectedUser.User.firstName} ${selectedUser.User.lastName}`;
    transactionDetails.operatorsName = operatorsName;

    transactionDetails.dynamicjson = JSON.stringify(dynamicFields);

    console.log("transactionDetails=================", transactionDetails);
    setPage("wait");
    let response = await moneyGramAPI(formValues, "MoneyGramSendValidation", {
      transactionDetails: JSON.stringify(transactionDetails),
    });
    console.log("this is the operators name in transactionddetails",transactionDetails.operatorsName);
    response = stripNamespaces(response);
    console.log("getQuote_response=================", response);
    if (response?.Status !== "2") {
      const sendValidationResponse =
        response?.payload?.body?.Envelope?.Body?.sendValidationResponse;
      const sendAmounts = sendValidationResponse.sendAmounts;
      const receiveAmounts = sendValidationResponse.receiveAmounts;
      const mgiTransactionSessionID =
        sendValidationResponse.mgiTransactionSessionID;
      const adminFees = response.adminFees;
      const taxes = response?.taxes?.taxamount;

      editTransactionDetails("fees", sendAmounts.totalSendFees);
      editTransactionDetails('taxes', taxes);
      //   editTransactionDetails("taxes", sendAmounts.totalSendTaxes);
      editTransactionDetails("adminFees", adminFees);
    //   editTransactionDetails(
    //     "totalAmountToCollect",
    //     parseFloat(sendAmounts.totalAmountToCollect) + parseFloat(adminFees)
    //   );
    editTransactionDetails('totalAmountToCollect', parseFloat(sendAmounts.totalAmountToCollect) + parseFloat(adminFees) + parseFloat(taxes));
      editTransactionDetails(
        "mgiTransactionSessionID",
        mgiTransactionSessionID
      );
      setPage("summary");
    } else if (response?.Status == "2") {
      const errorMessage = getMoneyGramErrorMessage(stripNamespaces(response));
setAlert({
  showAlert: true,
  severity: "error",
  message: errorMessage,
  header: "Error",
});
      setPage("landing");
      return;
    }
  };

   const getReceiveTransaction = async () => {
  let response = await moneyGramAPI(formValues, "getReceiveTransaction", {
    transactionDetails: JSON.stringify(transactionDetails),
  });

  response = stripNamespaces(response);
  console.log("Raw response (namespaces stripped)", response);

  const payload = response.payload;

 
if (payload?.callStatus == "0") {
  let userMessage = "An unknown error occurred.";

  const fault = payload?.apiresponse?.Envelope?.Body?.Fault;
  if (fault) {
    const errorObj = fault.detail?.["ac:errors"]?.["ac:error"];
    if (errorObj) {
      const err = Array.isArray(errorObj) ? errorObj[0] : errorObj;
      userMessage = err?.["ac:errorString"] || err?.detailString || userMessage;
    } else if (fault.faultstring) {
      userMessage = fault.faultstring;
    }
  }

  // Keep your existing offendingFields logic if needed, or just show the real message
  setAlert({
    showAlert: true,
    severity: "error",
    message: userMessage,
    header: "Transaction Not Available",
  });
  return;
}
  
  const refNumberResponse =
    payload?.body?.Envelope?.Body?.referenceNumberResponse;

  if (!refNumberResponse) {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Unexpected response format from MoneyGram.",
      header: "Error",
    });
    return;
  }

  console.log("Reference number response", refNumberResponse);

  // Destructure only the fields we actually need
  const {
    transactionStatus,
    mgiTransactionSessionID,
    senderFirstName,
    senderLastName,
    receiveAmount,
    receiveCurrency,
    originalSendAmount,
    originalSendCurrency,
    referenceNumber,
    originatingCountry,
    redirectIndicator,
    indicativeExchangeRate,
    indicativeReceiveAmount,
    receiverFirstName,
    receiverLastName,
    deliveryOption,
    expectedDateOfDelivery,
    sendPurposeOfTransaction,
  } = refNumberResponse;

  
  
  if (transactionStatus === "RECVD") {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "This Reference Number is already paid",
      header: "Error",
    });
    return;
  }
  if (transactionStatus === "CANCL") {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "This transaction has been canceled",
      header: "Error",
    });
    return;
  }
  if (transactionStatus !== "AVAIL") {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Transaction is not available for processing",
      header: "Error",
    });
    return;
  }

  
  setTransactionDetails((prev) => ({
    ...prev,
    amount: receiveAmount,
    senderName: `${senderFirstName} ${senderLastName}`.trim(),
    referencenumber: referenceNumber,
    mgiTransactionSessionID,
    receiveCurrency,
    originalSendAmount,
    originalSendCurrency,
    redirectIndicator,
    indicativeExchangeRate,
    indicativeReceiveAmount,
    receiverFirstName,
    receiverLastName,
    deliveryOption,
    expectedDateOfDelivery,
    sendPurposeOfTransaction,
    originatingCountry,
  }));

  editFormValues("senderFirstName", senderFirstName);
  editFormValues("senderLastName", senderLastName);
  editFormValues("amount", receiveAmount);
  editFormValues("mgiTransactionSessionID", mgiTransactionSessionID);

  
  if (redirectIndicator === "true") {
    setAlert({
      showAlert: true,
      severity: "info",
      message: `Currency conversion required – Rate: ${indicativeExchangeRate}, Receive: ${indicativeReceiveAmount} ${receiveCurrency}.`,
      header: "Currency Redirect",
    });
  }

  
  setPage("summary");
  editFormValues("transferType", "receive");
};

  const receiveMoney = async (pin) => {
  setPage("wait");
  console.log("calling receiveMoney...");
  let response;
  try {
    response = await moneyGramAPI(formValues, "receiveMoney", {
      transactionDetails: JSON.stringify(transactionDetails),
      PIN: pin,
    });
  } catch (error) {
    console.error("receiveMoney API failed:", error);
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Network error. Please try again.",
      header: "Error",
    });
    setPage("landing");
    return;
  }
 
  if (!response || typeof response !== "object") {
    console.error("Invalid response:", response);
    setAlertData({ Status: "2", payload: { header: { msg: "Invalid response from server" } } }, true);
    return;
  }
  console.log("receiveMoney response:", response);
  if (response.Status === "2" && response.payload?.msg === "Wrong user id or pin code") {
    setAlert({
      showAlert: true,
      severity: "error",
      message: response.payload.msg,
      header: "Invalid PIN",
    });
    
    setPage("summary");
    return;
  }
  if (response.Status === "2") {
  const realMessage = getMoneyGramErrorMessage(response);
 
  setAlert({
    showAlert: true,
    severity: "error",
    message: realMessage,
    header: "Transaction Rejected"
  });
  setPage("landing");
  return;
}
  if (response.Status !== "1") {
    setAlertData(response, true);
    return;
  }
  setPage("receiptReceive");
};

  const setUserData = (kyc) => {
    let senderKYC = {};

    if (!kyc?.sensData) {
    setTransactionDetails({ kyc: null });
    return;
  }
    let kycData = kyc.sensData ?? {};
    let kycCountry = kyc.kycCountry ?? '';

    let sensitiveData = kycData?.sensitiveData?.split("|");
    let kycState =
      kycData.shortcode === "Passport" ? sensitiveData[10] : sensitiveData[9];
    let kycIssueDate =
      kycData?.shortcode === "Passport" ? sensitiveData[9] : sensitiveData[8];
    kycIssueDate = kycIssueDate.split("-");
    kycIssueDate = kycIssueDate.reverse();
    kycIssueDate = kycIssueDate.join("");
    let kycExpDate =
      kycData?.shortcode === "Passport" ? sensitiveData[6] : sensitiveData[5];
    kycExpDate = kycExpDate.split("-");
    kycExpDate = kycExpDate.reverse();
    kycExpDate = kycExpDate.join("");
    let kycNumber = sensitiveData[4];
    let kycType = kycData.notes;
    senderKYC["type"] = kycType;
    senderKYC["number"] = kycNumber;
    senderKYC["issuingAgency"] = kycCountry;
    senderKYC["issuingAuthority"] = kycState;
    senderKYC["expirationDate"] = kycExpDate;
    senderKYC["issueDate"] = kycIssueDate;

    let extendedFields = kyc.extendedFields;
    extendedFields = extendedFields.replaceAll(/&(amp;)*quot;/g, '"');
    extendedFields = JSON.parse(extendedFields);
    senderKYC["citizenshipCountry"] = extendedFields.citizenshipcountry;
    setTransactionDetails({ kyc: senderKYC });
  };

 const trackTransaction = async (refNumber, data) => {
  setPage("wait");
  let parsed;
  let txDetails;
  try {
    parsed = JSON.parse(data);
    console.log("parsed in track", parsed);
  } catch (error) {
    console.error("Failed to parse outer JSON:", error);
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Invalid transaction data format.",
      header: "Parse Error",
    });
    setPage("landing");
    return;
  }
  try {
    // Decode any HTML entities in transactionDetails before parsing (handles &quot; cases)
    const innerJsonString = parsed.transactionDetails.replace(/&(amp;)*quot;/g, '"');
  
    if (!innerJsonString) {
      throw new Error("Missing 'transactionDetails' in history item");
    }
    txDetails = JSON.parse(innerJsonString);
  } catch (error) {
    console.error("Failed to parse transactionDetails:", error);
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Corrupted transaction details.",
      header: "Parse Error",
    });
    setPage("landing");
    return;
  }
  // NEW: Find the matching history record using refNumber (assuming refNumber === lookup2)
  const matchingRecord = history.find(record => record.Useritem.lookup2 === refNumber);
  if (!matchingRecord) {
    console.error("No matching history record found for refNumber:", refNumber);
    setAlert({
      showAlert: true,
      severity: "error",
      message: "Could not find transaction record.",
      header: "Error",
    });
    setPage("landing");
    return;
  }
  const recid = matchingRecord.Useritem.recid;
  console.log("Extracted recid from history:", recid);
  const sessionID = txDetails.mgiTransactionSessionID || "";
  try {
    const response = await moneyGramAPI(
      { referencenumber: refNumber },
      "MoneyGramDetailLookup",
      { recid: recid } // Send recid
    );
    console.log("response after detailLookup with recid:", response);
    if (
      response.Status !== "1" ||
      !response?.payload?.header?.callStatus ||
      response.payload.header.callStatus !== "1"
    ) {
      // === FAILURE: Use centralized function ===
      const errorMessage = getMoneyGramErrorMessage(response);
      setAlert({
        showAlert: true,
        severity: "error",
        message: errorMessage,
        header: "Track Failed",
      });
      setPage("landing");
      return;
    }
    const res = stripNamespaces(response);
    const detail = res.payload.body.Envelope.Body.detailLookupResponse;
    const status = detail.transactionStatus;
    let mappedStatus = "ERROR";
    if (status === "AVAIL") mappedStatus = "AVAIL";
    else if (status === "CANCL") mappedStatus = "CANCL";
    else if (status === "RECVD") mappedStatus = "RECVD";
    else if (status === "PRCSS") mappedStatus = "HOLD";
    else if (status === "AFR") mappedStatus = "AFR";
    setOrderStatus(mappedStatus);
    setRefundDetails({
      refid: refNumber,
      pcorderno: detail.referenceNumber,
      selectedOrderData: parsed,
      detailLookupResponse: res.payload.body.Envelope.Body.detailLookupResponse
    });
    setPage("track");
  } catch (apiError) {
    console.error("API Error in trackTransaction:", apiError);
    const errorMessage = getMoneyGramErrorMessage(apiError); // Use centralized function if apiError has response structure
    setAlert({
      showAlert: true,
      severity: "error",
      message: errorMessage || "Network error. Please try again later.",
      header: "Network Error",
    });
    setPage("landing");
  }
};

  const cancelTransaction = async () => {};

  
  const handleCancel = () => {
  setFormValues(prev => ({ ...prev, transferType: 'cancel' }));
  setCancelReasons([
    { key: "CHANGE_MIND", value: "CHANGE_MIND", label: "Customer Changed Mind" },
    { key: "INCORRECT_AMT", value: "INCORRECT_AMT", label: "Incorrect Send/Receive Amount" },
    
    
    { key: "NO_RCV_LOC", value: "NO_RCV_LOC", label: "No Receive Location" },
    { key: "WRONG_SERVICE", value: "WRONG_SERVICE", label: "Wrong Delivery Option" },
    { key: "NO_TQ", value: "NO_TQ", label: "Missing Test Question and Answer" },
    { key: "MS_NOT_USED", value: "MS_NOT_USED", label: "MoneyGram Plus or a Card Number Not Used" },
  ]);
  setPage("cancelform");
};
  const completeCancel = async () => {};

  const handleAmend = () => {
  const data = refundDetails.selectedOrderData;
  const txDetails = JSON.parse(data.transactionDetails);

  setAmendForm({
    receiverfirstname: txDetails.receiverFirstName || "",
    receiverlastname: txDetails.receiverLastName || "",
    referencenumber: refundDetails.refid,
    mgitransactionsessionid: txDetails.mgiTransactionSessionID || ""
  });

  setFormValues(prev => ({ ...prev, transferType: "amend" }));
  setPage("amendform");
};

const confirmCancel = async () => {
  console.log("txDetails========",JSON.parse(refundDetails.selectedOrderData.transactionDetails));
  console.log("txDetails22========",refundDetails?.detailLookupResponse?.dateTimeSent);
  let reversaltype = "R";

  const sentDateStr = refundDetails?.detailLookupResponse?.dateTimeSent;
  if (sentDateStr) {
    const sentDate = new Date(sentDateStr);
    const today = new Date();
  
    // Normalize both to YYYY-MM-DD
    const sentDateOnly = sentDate.toISOString().split('T')[0];
    const todayOnly = today.toISOString().split('T')[0];
    console.log("sentDateOnly=======",sentDateOnly);
    console.log("todayOnly=======",todayOnly);

    reversaltype = (sentDateOnly === todayOnly) ? "C" : "R";
  }
  console.log("reversaltype=======",reversaltype);

  setPage("wait");
  const txDetails = JSON.parse(refundDetails.selectedOrderData.transactionDetails);
  const requestData = {
    referencenumber: refundDetails.refid,
    sendamount: txDetails.amount,
    feeamount: txDetails.fees,
    sendcurrency: "USD",
    reversaltype: reversaltype,
    // reversaltype: cancelFormValues.reversaltype || "C",
    feerefund: "true",
    mgoperatorname: agent.firstName + " " + agent.lastName,
    location: "",
    reversaluserid: selectedUserID,
    sendreversalreason: cancelFormValues.sendreversalreason || "CHANGE_MIND",
    sendreversalreasonother: cancelFormValues.sendreversalreasonother || "",
    parentUser: selectedUser.User,
    parentuserid: parentuserid
  };
  console.log("payload", requestData);
  console.log("suserid", selectedUser.User.parentuserid || selectedUser.User.id);
  console.log("Reversal Request:", requestData);
  const response = await moneyGramAPI(requestData, "MoneyGramSendReversal");
  // Success check based on your existing logic
  if (!response?.data?.header?.callStatus || response.data.header.callStatus !== "1") {
    // === FAILURE: Use centralized function ===
    const errorMessage = getMoneyGramErrorMessage(response);
    setAlert({
      showAlert: true,
      severity: "error",
      message: errorMessage,
      header: "Cancellation Failed"
    });
    setPage("cancelform"); // Back to form for retry
    return;
  }
  const action = requestData.reversaltype === "C" ? "cancelled" : "refunded";
  setAlert({
    showAlert: true,
    severity: "success",
    message: `Transaction successfully ${action}.`,
    header: "Success",
  });
  setPage("landing");
};

 const confirmAmend = async () => {
  setPage("wait");
  const requestData = {
    referencenumber: amendForm.referencenumber,
    receiverfirstname: amendForm.receiverfirstname.trim(),
    receivermiddlename: "",
    receiverlastname: amendForm.receiverlastname.trim(),
    receiverlastname2: "",
    receivernamesuffix: "",
    receivernamesuffixother: "",
    receiverfirstnamenotavailable: "false",
    mgitransactionsessionid: amendForm.mgitransactionsessionid,
    location: "",
    mgoperatorname: agent.firstName + " " + agent.lastName
  };
  try {
    const response = await moneyGramAPI(requestData, "MoneyGramAmendTransaction");
    // === EXTRACT DATA SAFELY ===
    const data = response?.data;
    if (!data) {
      throw new Error("No response data received.");
    }
    const callStatus = data.header?.callStatus;
    const amendResponse = data.body?.Envelope?.["soapenv:Body"]?.["ac:amendTransactionResponse"];
    const transactionSucceeded = amendResponse?.["ac:transactionSucceeded"];
    // === SUCCESS CHECK ===
    if (callStatus === "1" && transactionSucceeded === "true") {
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Receiver name successfully updated.",
        header: "Success"
      });
      setPage("landing");
      return;
    }
    // === FAILURE: Use centralized function ===
    const errorMessage = getMoneyGramErrorMessage(response);
    throw new Error(errorMessage);
  } catch (error) {
    setAlert({
      showAlert: true,
      severity: "error",
      message: error.message || "Failed to amend transaction.",
      header: "Amend Failed"
    });
    setPage("amendform"); // Back to form for retry
  }
};

const validateSendPage1 = () => {
let errors = {};
let isValid = true;
if (!transactionDetails.receivercountry) {
errors.receivercountry = true;
isValid = false;
}
if (!transactionDetails.amounttype) {
errors.amounttype = true;
isValid = false;
}
if (!transactionDetails.amount || parseFloat(transactionDetails.amount) <= 0) {
errors.amount = true;
isValid = false;
}
if (!transactionDetails.relationshiptoreceiver) {
errors.relationshiptoreceiver = true;
isValid = false;
}
setFormErrors(errors);
if (!isValid) {
setAlert({
showAlert: true,
severity: "error",
message: "Please fill all the fields properly",
header: "Validation Error",
});
}
return isValid;
};

  return (
    <Box className="container">
      <Box className="pageContainer" sx={{ width: "100%", margin: "auto" }}>
        <Typography
          sx={{
            fontFamily: "'Nunito'",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "21.4825px",
            color: "#3A3A3A",
          }}
          className="text-center"
        >
          International Transfer - Moneygram 2
        </Typography>
        {page === "landing" ? (
          <Box>
            <Box className="contactContainer">
              <Box className="d-flex justify-content-between">
                <Box className="lh-lg fw-bold">Contacts</Box>
              </Box>
              <Contacts
                contacts={contacts}
                service={"MoneyGram"}
                setSelectedContact={setSelectedContact}
              />
            </Box>
            <Box className="historyContainer mt-3">
              <Box className="fw-bold">Recent History</Box>
              <InternationalTransferHistory
                history={history}
                service={"MONEYGRAM"}
                trackTransaction={(refNumber, data) => trackTransaction(refNumber, data)}
                handleResend={(item) => resendTransaction(item)}
              />
            </Box>
            <InternationalTransferFooterButtons
              handleButtonOne={handleBack}
              handleButtonTwo={() => setPage("receive")}
              handleMiddleButton={() => setPage("sendpage1")}
              buttonOneText="Return"
              buttonTwoText="Receive Money"
              middleButtonText="Send Money To New Contact"
              showMiddleButton={true}
              showButtonTwo={isDevEnv ? true : false}
            />
          </Box>
        ) : (
          ""
        )}
        {page === "sendpage1" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
               <RegistrationSelect
                label="Receiving Country"
                type="text"
                options={countries}
                onChange={(e) => {
                  const code = e.target.value;
                  const selected = countries.find(c => c.value === code);
                  if (selected && !selected.isSendActive) {
                    setAlert({
                      showAlert: true,
                      severity: "error",
                      message: "Send transaction is not available for this country via MoneyGram.",
                      header: "Invalid Country",
                    });
                    return;  // Prevent setting invalid country
                  }
                  editTransactionDetails("receivercountry", code);
                }}
                value={transactionDetails.receivercountry}
                required={true}
                hasError={formErrors.receivercountry}
              />
            <RegistrationSelect
              label="Entered Amount includes fees"
              type="text"
              options={[
                { key: "withFee", value: "withFee", label: "Yes" },
                { key: "withoutFee", value: "withoutFee", label: "No" },
              ]}
              onChange={(e) => {
                editTransactionDetails("amounttype", e.target.value);
              }}
              value={transactionDetails.amounttype}
              required={true}
              hasError={formErrors.amounttype}
            />
            <RegistrationInput
              label="Amount"
              required={true}
              onChange={(e) => editTransactionDetails("amount", e.target.value)}
              value={transactionDetails.amount}
              hasError={formErrors.amount}
            />
            <RegistrationSelect
              label="Relationship to Receiver"
              options={relationships ?? []}
              required={true}
              onChange={(e) =>
                editTransactionDetails("relationshiptoreceiver", e.target.value)
              }
              value={transactionDetails.relationshiptoreceiver}
              hasError={formErrors.relationshiptoreceiver}
            />
            <InternationalTransferFooterButtons
              handleButtonOne={() => setPage("landing")}
              handleButtonTwo={() => {
                const isValid = validateSendPage1();
                if (isValid) {
                getPayoutOptions();
                }
                }}
              buttonOneText="Back"
              buttonTwoText="Next"
              showMiddleButton={false}
              showButtonTwo={true}
            />
          </Box>
        ) : (
          ""
        )}
        {page === "summary" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <InternationalTransferSummary
              transferDetails={transactionDetails}
              type={
                formValues.transferType === "send" ||
                formValues.transferType === "resend"
                  ? "send"
                  : "receive"
              }
              handleReturn={() => setPage("landing")}
              service="MoneyGram"
              user={selectedUser}
              handleContinue={() => {
  setFraudChecked(false);           // Reset checkbox
  setShowFraudDialog(true);         // Open dialog
}}
              handleSaveContact={saveContact}
              contactButtonText={contactButtonText}
              disableSaveContact={disableContactButton}
            />
          </Box>
        ) : (
          ""
        )}

        {page === "sendpage2" ? (
  <Box sx={{ maxHeight: "600px", marginTop: "10px" }}>
    
    {/* NEW: Info Note when previous delivery option exists (resend/contact) */}
    {prevDeliveryOption && (
      (() => {
        let prev;
        try {
          prev = JSON.parse(prevDeliveryOption);
        } catch (e) {
          return null;
        }

        return (
          <Box
            sx={{
              backgroundColor: "#e3f2fd",
              border: "1px solid #2196f3",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "24px",
              borderLeft: "5px solid #2196f3",
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 600, color: "#1976d2", mb: 0.5 }}>
              Previous Payout Method:
            </Typography>
            <Typography variant="body2" sx={{ color: "#0d47a1" }}>
              <strong>{prev.deliveryOptDisplayName}</strong> 
              {prev.validReceiveCurrency && ` • ${prev.validReceiveCurrency}`}
              {prev.receiveAgentName && ` • ${prev.receiveAgentName}`}
            </Typography>
            <Typography variant="body2" sx={{ color: "#1976d2", mt: 1, fontSize: "0.9rem" }}>
              If you select a different option, <strong>additional receiver details may be required</strong>.
            </Typography>
          </Box>
        );
      })()
    )}

    <RegistrationSelect
      label="Payout Option"
      type="text"
      options={payoutOptionsSelectable}
      onChange={(e) => {
        editTransactionDetails("deliveryoption", e.target.value);
        setHasSelectedPayout(true);
      }}
      value={transactionDetails.deliveryoption || ""}
      required={true}
      hasError={formErrors.deliveryoption}
    />

    <InternationalTransferFooterButtons
      handleButtonOne={() => setPage("shortform")}
      handleButtonTwo={async () => {
        if (!transactionDetails.deliveryoption  || !hasSelectedPayout) {
          setFormErrors({ deliveryoption: "This field is required." });
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Please select a payout option.",
            header: "Error",
          });
          return;
        }

        const selectedOption = JSON.parse(transactionDetails.deliveryoption);
        const prevOption = prevDeliveryOption ? JSON.parse(prevDeliveryOption) : null;
        //New change for moneygram//
        const isSamePayout =
          prevOption &&
          selectedOption.deliveryOptDisplayName ===
            prevOption.deliveryOptDisplayName &&
          selectedOption.validReceiveCurrency ===
            prevOption.validReceiveCurrency &&
          selectedOption.receiveCountry === prevOption.receiveCountry;
        // NEW: Even if same payout, force sendpage3 if compliance fields are missing
  const complianceFilled =
    transactionDetails.sendPurposeOfTransaction?.trim() &&
    transactionDetails.senderIntendedUseOfMGIServices?.trim();

        // if (prevOption &&
        //   selectedOption.deliveryOptDisplayName === prevOption.deliveryOptDisplayName &&
        //   selectedOption.validReceiveCurrency === prevOption.validReceiveCurrency &&
        //   selectedOption.receiveCountry === prevOption.receiveCountry) {
          
        //   await getQuote();
        // } else {
          
        //   await getFieldData();
        // }
        if (isSamePayout && complianceFilled) {
          await getQuote(); // safe to skip sendpage3
        } else {
          await getFieldData(); // go to sendpage3 (different payout OR missing compliance)
        }
      }}
      buttonOneText="Back"
      buttonTwoText="Next"
      showMiddleButton={false}
      showButtonTwo={true}
    />
  </Box>
) : ("")}

        {page === "sendpage3" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <MoneyGramReceiverFields
              receiverFields={receiverFields}
              formValues={formValues}
              formErrors={formErrors}
              countries={countries}
              editFormValues={editFormValues}
              setTransactionDetails={editTransactionDetails}
              transactionDetails={transactionDetails}
              stateProvinceInfo={stateProvinceInfo}
            />

            <InternationalTransferFooterButtons
              handleButtonOne={() => setPage("sendpage2")}
              handleButtonTwo={getQuote}
              buttonOneText="Back"
              buttonTwoText="Next"
              showMiddleButton={false}
              showButtonTwo={true}
            />
          </Box>
        ) : (
          ""
        )}

        {page === "receive" ? (
  <Box sx={{ maxHeight: "600px", marginTop: "10px" }}>
    <RegistrationInput
      label="Reference Number"
      required={true}
      onChange={(e) => {
        const value = e.target.value.trim();
        editFormValues("referencenumber", value);
        // Clear error when user starts typing
        if (formErrors.referencenumber && value) {
          setFormErrors(prev => ({ ...prev, referencenumber: false }));
        }
      }}
      value={formValues.referencenumber || ""}
      hasError={!!formErrors.referencenumber}  // <-- this triggers red border
    />
    <InternationalTransferFooterButtons
      handleButtonOne={() => setPage("landing")}
      handleButtonTwo={() => {
        const ref = (formValues.referencenumber || "").trim();
        if (!ref) {
          setFormErrors({ referencenumber: true });
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Please enter a reference number",
            header: "Missing Reference Number",
          });
          return;
        }
        if (ref.length !== 8) {
          setFormErrors({ referencenumber: true });
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Reference number must be exactly 8 digits",
            header: "Invalid Reference Number",
          });
          return;
        }
        getReceiveTransaction();  // Only call API if valid
      }}
      buttonOneText="Back"
      buttonTwoText="Next"
      showMiddleButton={false}
      showButtonTwo={true}
    />
  </Box>
) : ("")}

        {page === "receipt" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <InternationalTransferSummary
              type="send"
              transferDetails={transactionDetails}
              handleReturn={() => setPage("landing")}
              user={selectedUser}
              handleContinue={() => setPage("landing")}
              isReceipt={true}
              service={"MoneyGram"}
            />
          </Box>
        ) : (
          ""
        )}

        {page === "receiptReceive" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <InternationalTransferSummary
              type="receive"
              transferDetails={transactionDetails}
              handleReturn={() => setPage("landing")}
              user={selectedUser}
              handleContinue={() => setPage("landing")}
              isReceipt={true}
              service={"MoneyGram"}
            />
          </Box>
        ) : (
          ""
        )}

        {page === "wait" || page === "init" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <Box className="mt-5 d-flex justify-content-center align-items-center">
              <CircularProgress size="10rem" />
            </Box>
          </Box>
        ) : (
          ""
        )}

        {page === "shortform" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            <RegistrationInput
              label="Amount"
              type="number"
              onChange={(e) => editTransactionDetails("amount", e.target.value)}
              value={transactionDetails.amount}
              hasError={formErrors.amount}
            />

            <RegistrationSelect
              label="Entered Amount includes fees"
              type="text"
              options={[
                { key: "withFee", value: "withFee", label: "Yes" },
                { key: "withoutFee", value: "withoutFee", label: "No" },
              ]}
              onChange={(e) => {
                editTransactionDetails("amounttype", e.target.value);
              }}
              value={transactionDetails.amounttype}
              required={true}
              hasError={formErrors.amounttype}
            />
            <InternationalTransferFooterButtons
              handleButtonOne={() => setPage("init")}
              handleButtonTwo={() => {
                              const isValid = validateShortForm();
                              if (isValid) {
                                getPayoutOptions();
                              }
                            }}
              buttonOneText="Return"
              buttonTwoText="Continue"
            />
          </Box>
        ) : (
          ""
        )}

        {page === "contact" ? (
          <Box
            sx={{
              maxHeight: "600px",
              marginTop: "10px",
            }}
          >
            {getContactInformation()}

            <InternationalTransferFooterButtons
              handleButtonOne={() => setPage("init")}
              handleButtonTwo={() => sendToContact()}
              buttonOneText="Cancel"
              buttonTwoText="Send To This Contact"
            />
          </Box>
        ) : (
          ""
        )}

        {page === "track" && (
          <InternationalTransferTrack
            transactionStatus={orderStatus}
            handleReturn={() => setPage("landing")}
            isCancellable={orderStatus === "AVAIL"}
            handleCancel={handleCancel}
            handleAmend={handleAmend} 
            intlTransfer={'Moneygram'}
          />
        )}

                            {/* FRAUD WARNING DIALOG */}
                  <Dialog
                    open={showFraudDialog}
                    onClose={() => setShowFraudDialog(false)}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle>MoneyGram Fraud Warning</DialogTitle>
                    <DialogContent dividers>
                      <Typography
                        component="pre"
                        sx={{
                          whiteSpace: "pre-wrap",
                          fontFamily: "inherit",
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                        }}
                      >
                        {FRAUD_WARNING}
                      </Typography>

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={fraudChecked}
                            onChange={(e) => setFraudChecked(e.target.checked)}
                            size="small"
                          />
                        }
                        label="I have read and understand the warning above."
                        sx={{ mt: 2 }}
                      />
                    </DialogContent>

                    <DialogActions>
                      <Button onClick={() => setShowFraudDialog(false)}>
                        Back
                      </Button>
                      <Button
                        onClick={() => {
                          if (fraudChecked) {
                            setShowFraudDialog(false);
                            setShowPin(true);  // Only now show PinPad
                          }
                        }}
                        variant="contained"
                        disabled={!fraudChecked}
                      >
                        Continue
                      </Button>
                    </DialogActions>
                  </Dialog>
        {showPin && (
          <PinPad
            show={showPin}
            handleConfirm={handlePinConfirm}
            onClick={() => setShowPin(false)}
          />
        )}

        {page === "cancelform" && (
                  <Box sx={{ maxHeight: "600px", marginTop: "10px" }}>
                    <RegistrationSelect
                      label="Reason for Cancellation"
                      options={cancelReasons}
                      required={true}
                      onChange={(e) => setCancelFormValues(prev => ({
                        ...prev,
                        sendreversalreason: e.target.value,
                        sendreversalreasonother: e.target.value === "OTHER" ? "" : undefined
                      }))}
                      value={cancelFormValues.sendreversalreason || ""}
                      hasError={!cancelFormValues.sendreversalreason}
                    />
                    {cancelFormValues.sendreversalreason === "OTHER" && (
                      <RegistrationInput
                        label="Other Reason"
                        onChange={(e) => setCancelFormValues(prev => ({
                          ...prev,
                          sendreversalreasonother: e.target.value
                        }))}
                        value={cancelFormValues.sendreversalreasonother || ""}
                      />
                    )}

                    {/* NEW: Reversal Type */}
                    {/* <RegistrationSelect
                      label="Action"
                      options={[
                        { key: "C", value: "C", label: "Cancel & Refund (Full Reversal)" },
                        { key: "R", value: "R", label: "Refund Only (Keep Transaction)" },
                      ]}
                      required={true}
                      onChange={(e) => setCancelFormValues(prev => ({
                        ...prev,
                        reversaltype: e.target.value
                      }))}
                      value={cancelFormValues.reversaltype || "C"}
                    /> */}

                    <InternationalTransferFooterButtons
                      handleButtonOne={() => setPage("track")}
                      handleButtonTwo={() => {
                        if (!cancelFormValues.sendreversalreason) {
                          setAlert({
                            showAlert: true,
                            severity: "error",
                            message: "Please select a reason.",
                            header: "Error"
                          });
                          return;
                        }
                        confirmCancel();
                      }}
                      buttonOneText="Back"
                      buttonTwoText="Proceed"
                    />
                  </Box>
                )}

                {page === "amendform" && (
  <Box sx={{ maxHeight: "600px", marginTop: "10px" }}>
    <RegistrationInput
      label="Receiver First Name"
      required={true}
      value={amendForm.receiverfirstname}
      onChange={(e) => setAmendForm(prev => ({ ...prev, receiverfirstname: e.target.value }))}
      hasError={!amendForm.receiverfirstname.trim()}
    />
    <RegistrationInput
      label="Receiver Last Name"
      required={true}
      value={amendForm.receiverlastname}
      onChange={(e) => setAmendForm(prev => ({ ...prev, receiverlastname: e.target.value }))}
      hasError={!amendForm.receiverlastname.trim()}
    />

    <InternationalTransferFooterButtons
      handleButtonOne={() => setPage("track")}
      handleButtonTwo={() => {
        if (!amendForm.receiverfirstname.trim() || !amendForm.receiverlastname.trim()) {
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Both first and last name are required.",
            header: "Error"
          });
          return;
        }
        confirmAmend();
      }}
      buttonOneText="Back"
      buttonTwoText="Amend Transaction"
    />
  </Box>
)}
      </Box>
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prev) => setAlert({ ...prev, showAlert: false })}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
}

export default Moneygram;